// src/store/slices/loanTypeSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchLoanTypeUrl, createLoanTypeUrl } from '../../services/masters/LoanTypesService';
import { ACTIONS } from '../../constants/apiEndpoints';

export const fetchLoanTypes = createAsyncThunk(
  ACTIONS.loan_types,
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchLoanTypeUrl();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const loanTypeSlice = createSlice({
  name: 'loanTypes',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLoanTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchLoanTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const createLoanType = createAsyncThunk(
  ACTIONS.create_loan_types,
  async (loanTypeObj, { rejectWithValue }) => {
    try {
      const payload = {
        data: JSON.stringify(loanTypeObj), // stringified inner data
        target: 'society.models.master.loanTypes.LoanType',
        compressed: false
      };
      const response = await createLoanTypeUrl(payload);
      
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export default loanTypeSlice.reducer;
